import { useQuery } from "@tanstack/react-query"
import type { ProjectListResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function useProjects(propertyId: string | undefined) {
	return useQuery({
		queryKey: propertyId
			? queryKeys.projects(propertyId)
			: ["properties", "__nil__", "projects"],
		queryFn: () =>
			apiFetch<ProjectListResponse>(
				`/api/common/properties/${propertyId}/projects`,
			).then((res) => res.projects),
		enabled: !!propertyId,
	})
}
